export default __webpack_public_path__ + "static/logo_ifrc-36b17eda48bfb8cd6b233a99f4f5d768.png";